import type { ReactNode } from "react";
import {
  initializeSettingsDraftSession,
  SettingsDraftSessionContext,
} from "./settings-draft-state";

export function SettingsDraftProvider({
  sessionId,
  children,
}: {
  sessionId: string | null;
  children: ReactNode;
}) {
  initializeSettingsDraftSession(sessionId);
  return (
    <SettingsDraftSessionContext.Provider key={sessionId} value={sessionId}>
      {children}
    </SettingsDraftSessionContext.Provider>
  );
}
